import React from 'react';
import { ReactComponent as Icon } from '../../../assets/icon-chevron-left.svg';
import createSvgIcon from '../../../shared/utils/create-svg-icon';

export const ChevronLeftIcon = createSvgIcon(<Icon />, 'ChevronLeftIcon');
